import type { IThemePageInfo } from '~/types/themePage';
import type { IThemePage } from '~/stores/themePage';

import { ProviderSource } from '~/types/template';
import { parseTemplateIdBy } from '~/utils';

export const checkTemplateDefaultOnGP = (
  themePages?: IThemePage[],
  templateSuffix?: string,
): boolean => {
  if (!templateSuffix || !themePages?.length) return false;

  const themePageId = parseTemplateIdBy(templateSuffix, ProviderSource.GEMPAGESV7);
  return themePages.some(
    (themePage) =>
      themePage.id === themePageId &&
      themePage.default &&
      themePage.providerSource === ProviderSource.GEMPAGESV7,
  );
};

export const checkIsShowBadgeDefault = (data?: IThemePageInfo): boolean => {
  if (!data) return false;
  return (
    data.providerSource === ProviderSource.SHOPIFY_ORIGIN &&
    data.defaultByProvider === ProviderSource.GEMPAGESV7
  );
};
